import { FuelCallout } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { SkeletonList } from 'components/Skeleton/SkeletonList';
import TruckerListItem from 'components/TruckerListItem';
import { SearchTruckerMessageError } from 'config/truckerProfileService';
import { dsTheme } from 'constants/styled.contants';
import { TTruckerItem } from 'context/reducers/truckers.type';
import { useAppContext } from 'hooks/useAppContext';
import React from 'react';
import { isEmpty } from 'utils/isEmpty';
import { DESKTOP_CARD_HEIGHT, MOBILE_CARD_HEIGHT, MOBILE_NO_CHECKIN_CARD_HEIGHT } from '../constants';
import ListHeader from '../ListHeader';
import Empty from './States/Empty';
import Inactive from './States/Inactive';
import LoadError from './States/LoadError';

const SearchedTrucker = () => {
  const {
    state: {
      deviceSize: { isDesktop, isTablet, isMobile },
      searchTruckers: { dataSearch, isFetchingSearch, isFetchedSearch, term, errorSearch },
    },
  } = useAppContext();

  const showLoadingState = isFetchingSearch;
  const showSearchedTrucker = !isFetchingSearch && isFetchedSearch && !isEmpty(dataSearch);
  const showEmptyState =
    isFetchedSearch &&
    !isFetchingSearch &&
    (errorSearch === SearchTruckerMessageError.notFound || errorSearch === SearchTruckerMessageError.duplicated);
  const showInactiveState = isFetchedSearch && !isFetchingSearch && errorSearch === SearchTruckerMessageError.notActive;
  const showLoadErrorState =
    isFetchedSearch && !isFetchingSearch && errorSearch === SearchTruckerMessageError.undefined;
  const showInfoCallout = (term === null || term?.length <= 10) && !isFetchingSearch && !isFetchedSearch;

  const mapedTruckerItem: TTruckerItem = {
    lastLocation: {
      coordinate: {
        lat: dataSearch?.trucker?.lastLocation?.coordinates?.latitude,
        lng: dataSearch?.trucker?.lastLocation?.coordinates?.longitude,
      },
      verified: dataSearch?.trucker?.lastLocation?.hasDistance,
      distance: dataSearch?.trucker?.lastLocation?.distance,
      date: null,
    },
    checkin: {
      destination: dataSearch?.trucker?.availability?.destination,
    },
    vehicle: {
      bodyName: dataSearch?.trucker?.vehicles?.[0]?.body?.[0]?.name,
      typeName: dataSearch?.trucker?.vehicles?.[0]?.tractor?.type,
      plate: dataSearch?.trucker?.vehicles?.[0]?.tractor?.plate,
      id: dataSearch?.trucker?.vehicles?.[0]?.id,
    },
    person: {
      areaCodes: Array.from(new Set(dataSearch?.trucker?.phones?.map((phone) => phone.ddd))),
      isVip: dataSearch?.trucker?.isVip,
      id: dataSearch?.trucker?.id,
      name: dataSearch?.trucker?.name,
      selfieUri: dataSearch?.trucker?.selfieUri,
      verified: dataSearch?.isVerified,
      uuid: dataSearch?.trucker?.uuid,
      whereIs:
        dataSearch?.trucker?.lastLocation?.city && dataSearch?.trucker?.lastLocation?.state
          ? `${dataSearch.trucker.lastLocation.city}, ${dataSearch.trucker.lastLocation.state}`
          : undefined,
    },
  };

  const getRowHeight = () => {
    if (isDesktop || isTablet) return DESKTOP_CARD_HEIGHT;

    if (isMobile && !mapedTruckerItem?.checkin?.createdAt) return MOBILE_NO_CHECKIN_CARD_HEIGHT;

    return MOBILE_CARD_HEIGHT;
  };

  return (
    <>
      {showLoadingState && <SkeletonList selfPadding />}
      {showEmptyState && <Empty />}
      {showInactiveState && <Inactive />}
      {showLoadErrorState && <LoadError />}

      {showSearchedTrucker && isDesktop && <ListHeader />}
      {showSearchedTrucker && (
        <TruckerListItem bindSearchTag startAsVisualized truckerItem={mapedTruckerItem} height={getRowHeight()} />
      )}

      {showInfoCallout && (
        <FuelFlex
          smProps={{ customPadding: `0 ${dsTheme.spacing.km4}` }}
          mdProps={{ customPadding: `0 ${dsTheme.spacing.km4}` }}
        >
          <FuelCallout
            icon="view-search"
            iconStyle="outlined"
            message="A busca será realizada em toda a base de motoristas da Fretebras, não apenas na lista de sugeridos."
            fullWidth
            data-testid="callout-search-info"
          />
        </FuelFlex>
      )}
    </>
  );
};

export default SearchedTrucker;
